<template>
  <exo-help-dialog title="ΔRAAN">
    Here ΔRAAN must be understood as a relative RAAN phasing with respect to the
    chosen RAAN phasing reference. See mission description for more details.
  </exo-help-dialog>
</template>

<script>
export default {
  name: 'tooltipTargetDeltaRaan'
}
</script>
